import { Box, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import GlobalButton from "../../../components/CustomButton";
import Label from "../../../components/Label";
import TextInput from "../../../components/TextInputs";
import appcolors from "../../../constants/Colors";
import { useNavigate } from "react-router-dom";
import { resetValidation } from "../../../utils/Validation";

const ResetPasswordForm = () => {
  const navigate = useNavigate();
  // States
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const [inputValues, setInputValues] = useState({
    password: "",
    confirmPass: "",
  });
  const [inputError, setInputError] = useState({
    password: false,
    confirmPass: false,
    isPasswordValid: false,
  });

  // Function

  const handleResetPassword = async () => {
    try {
      const validate = resetValidation(inputValues, setInputError);
      if (validate) {
        return;
      }
      navigate("/login");
      // localStorage.setItem("user-data", JSON.stringify(payload));
    } catch (error) {}
  };

  const handleChangeValues = (event) => {
    const { name, value } = event.target;
    setInputError((prevError) => ({
      ...prevError,
      [name]: false,
      isPasswordValid:
        name === "confirmPass" ? false : inputError.isPasswordValid,
    }));
    setInputValues((pre) => ({ ...pre, [name]: value }));
  };
  return (
    <Box component={"form"} sx={{ mt: 6 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Label labelText="New Password" htmlFor={"password"} required />
          <TextInput
            inputError={inputError.password}
            helperText={inputError.password ? "New password is required" : null}
            id={"password"}
            required
            placeholder={"Enter New Password"}
            type={showPass ? "text" : "password"}
            name="password"
            value={inputValues.password}
            onChange={handleChangeValues}
            InputEndIcon={
              showPass ? (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowPass(false)}
                >
                  Hide
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowPass(true)}
                >
                  Show
                </Typography>
              )
            }
          />
        </Grid>
        <Grid item xs={12}>
          <Label labelText="Re-Enter" htmlFor={"password-confirm"} required />
          <TextInput
            inputError={inputError.confirmPass || inputError.isPasswordValid}
            helperText={
              inputError.confirmPass
                ? "Confirm password is required"
                : inputError.isPasswordValid
                ? "Password does not match"
                : null
            }
            id={"password-confirm"}
            required
            placeholder={"Re-Enter Password"}
            type={showConfirmPass ? "text" : "password"}
            name="confirmPass"
            value={inputValues.confirmPass}
            onChange={handleChangeValues}
            InputEndIcon={
              showConfirmPass ? (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowConfirmPass(false)}
                >
                  Hide
                </Typography>
              ) : (
                <Typography
                  variant="body2"
                  color={appcolors.black}
                  onClick={() => setShowConfirmPass(true)}
                >
                  Show
                </Typography>
              )
            }
          />
        </Grid>
      </Grid>
      <Box mt={5}>
        <GlobalButton
          variant={"contained"}
          btnText={"Next"}
          handleClickBtn={handleResetPassword}
        />
      </Box>
    </Box>
  );
};

export default ResetPasswordForm;
